import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "./popSearch";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";

export default function FormDeduction({ formda, setFormda, open, setOpen , existingComponents = [],
 }) {
  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);
  const [radioType, setRadioType] = useState("amount");
  const [errors, setErrors] = useState({
    empId: false,
    componentName: false,
    amount: false,
    percentage: false,
  });
  const [errorMessages, setErrorMessages] = useState({
    empId: "",
    componentName: "",
    amount: "",
    percentage: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  // Initialize form structure
  const formStruct = {
    empId: formda?.empId || "",
    employeeName: formda?.employeeName || "",
    componentName: "",
    amount: "",
    percentage: "",
    componentDetails: formda?.componentDetails || [],
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };
    const newErrorMessages = { ...errorMessages };

    // Validate employee selection
    if (!formda?.empId) {
      newErrors.empId = true;
      newErrorMessages.empId = "Please select an employee";
      isValid = false;
    } else {
      newErrors.empId = false;
      newErrorMessages.empId = "";
    }

    // Validate component name
    if (!formda?.componentName?.trim()) {
      newErrors.componentName = true;
      newErrorMessages.componentName = "Component name is required";
      isValid = false;
    } else {
      newErrors.componentName = false;
      newErrorMessages.componentName = "";
    }

    // Validate amount/percentage based on radioType
    if (radioType === "amount") {
      if (
        !formda?.amount ||
        isNaN(formda.amount) ||
        Number(formda.amount) <= 0
      ) {
        newErrors.amount = true;
        newErrorMessages.amount = "Please enter a valid positive amount";
        isValid = false;
      } else {
        newErrors.amount = false;
        newErrorMessages.amount = "";
      }
    } else {
      if (
        !formda?.percentage ||
        isNaN(formda.percentage) ||
        Number(formda.percentage) <= 0 ||
        Number(formda.percentage) > 100
      ) {
        newErrors.percentage = true;
        newErrorMessages.percentage = "Please enter a valid percentage (1-100)";
        isValid = false;
      } else {
        newErrors.percentage = false;
        newErrorMessages.percentage = "";
      }
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);
    return isValid;
  };

  const resetFormFields = () => {
    setFormda((prev) => ({
      ...prev,
      componentName: "",
      amount: "",
      percentage: "",
    }));
    setErrors({
      empId: false,
      componentName: false,
      amount: false,
      percentage: false,
    });
    setErrorMessages({
      empId: "",
      componentName: "",
      amount: "",
      percentage: "",
    });
    setFormSubmitted(false);
  };

  const handleAddComponent = () => {
    setFormSubmitted(true);
    if (!validateForm()) {
      return;
    }
     const employeeData = existingComponents.find(
          (emp) => emp.empId === formda.empId
        );
    
        // Step 2: If found, check if the component already exists
        const componentExistsInBackend = employeeData?.componentDetails?.some(
          (comp) =>
            comp.componentName.trim().toLowerCase() ===
            formda.componentName.trim().toLowerCase()
        );
    
        if (componentExistsInBackend) {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            title: "This component already exists for this employee.",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "swal2-toast",
            },
            didOpen: (toast) => {
              toast.style.zIndex = 2000;
            },
          });
          return;
        }

       const isDuplicate = formda?.componentDetails?.some(
          (comp)=> comp.componentName.trim().toLowerCase()===formda.componentName.trim().toLowerCase()
        )
    
         if (isDuplicate) {
             Swal.fire({
               toast: true,
               position: "top-end",
               icon: "warning",
               title: "This component has already been added.",
               showConfirmButton: false,
               timer: 3000,
               timerProgressBar: true,
               customClass: {
                 popup: "swal2-toast",
               },
             });
           return;
        }

    setFormda((prev) => ({
      ...prev,
      componentDetails: [
        ...(prev.componentDetails || []),
        {
          componentName: prev.componentName,
          amount: radioType === "amount" ? Number(prev.amount) : 0,
          percentage: radioType === "percentage" ? Number(prev.percentage) : 0,
        },
      ],
    }));

    resetFormFields();
  };

  useEffect(() => {
    if (open && formda?.empId) {
      setSearchvalue(formda?.employeeName || "");
    }
  }, [open, formda]);

  return (
    <Box>
      <Grid container sx={{ position: "relative" }}>
        <Grid item xs={12} sx={{ p: 0 }}>
          <Grid
            container
            spacing={2}
            sx={{ position: "relative", padding: "10px 20px" }}
          >
            <Grid item xs={12} sm={12}>
              <FormControl fullWidth error={errors.empId}>
                {/* <TextFieldSearch
                  label={"Select Employee"}
                  search={search}
                  notEditable={!!formda?.empId}
                  setOpen={setSearchModal}
                  error={errors.empId}
                  helperText={errorMessages.empId}
                /> */}
                <TextField
                  label="Select Employee"
                  value={search}
                  InputLabelProps={{
                    className: "mulish",
                    shrink: !!search,
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  size="small"
                  InputProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                    classes: { input: "mulish" },
                    endAdornment: (
                      <SearchIcon
                        onClick={() => {
                          setSearchModal(true);
                        }}
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          cursor: "pointer",
                        }}
                      />
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&:hover fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #01008B",
                      },
                      cursor: "pointer",
                    },
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={errors.componentName}>
                <TextField
                  label="Deduction Name"
                  name="componentName"
                  value={formda?.componentName || ""}
                  onChange={(e) => {
                    setFormda({ ...formda, componentName: e.target.value });
                    if (e.target.value.trim()) {
                      setErrors({ ...errors, componentName: false });
                      setErrorMessages({ ...errorMessages, componentName: "" });
                    }
                  }}
                  required
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&:hover fieldset": {
                        border: "1px solid #01008B",
                      },
                      "&.Mui-focused fieldset": {
                        border: "1px solid #01008B",
                      },
                      cursor: "pointer",
                    },
                  }}
                  error={errors.componentName && formSubmitted}
                  helperText={formSubmitted ? errorMessages.componentName : ""}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{
                    classes: { input: "mulish" },
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                />
              </FormControl>
            </Grid>

            {/* <Grid item xs={12} sm={12}>
              <FormControl fullWidth>
                <RadioGroup
                  row
                  value={radioType}
                  onChange={(e) => {
                    setRadioType(e.target.value);
                    // Clear validation errors when switching types
                    setErrors({ ...errors, amount: false, percentage: false });
                    setErrorMessages({
                      ...errorMessages,
                      amount: "",
                      percentage: "",
                    });
                  }}
                >
                  <FormControlLabel
                    value="amount"
                    control={<Radio />}
                    label="Amount"
                    className="mulish"
                  />
                  <FormControlLabel
                    value="percentage"
                    control={<Radio />}
                    label="Percentage"
                    className="mulish"
                  />
                </RadioGroup>
              </FormControl>
            </Grid> */}

            {radioType === "amount" && (
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={errors.amount && formSubmitted}>
                  <TextField
                    label="Amount"
                    name="amount"
                    value={formda?.amount || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && Number(value) >= 0) {
                        setFormda({
                          ...formda,
                          amount: value,
                        });
                        setErrors({ ...errors, amount: false });
                        setErrorMessages({ ...errorMessages, amount: "" });
                      }
                    }}
                    required
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&:hover fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #01008B",
                        },
                        cursor: "pointer",
                      },
                    }}
                    error={errors.amount && formSubmitted}
                    helperText={formSubmitted ? errorMessages.amount : ""}
                    type="number"
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      classes: { input: "mulish" },
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                      inputProps: { min: 0 },
                    }}
                  />
                </FormControl>
              </Grid>
            )}

            {radioType === "percentage" && (
              <Grid item xs={12} sm={6}>
                <FormControl
                  fullWidth
                  error={errors.percentage && formSubmitted}
                >
                  <TextField
                    label="Percentage"
                    name="percentage"
                    value={formda?.percentage || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        !isNaN(value) &&
                        Number(value) >= 0 &&
                        Number(value) <= 100
                      ) {
                        setFormda({
                          ...formda,
                          percentage: value,
                        });
                        setErrors({ ...errors, percentage: false });
                        setErrorMessages({ ...errorMessages, percentage: "" });
                      }
                    }}
                    required
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&:hover fieldset": {
                          border: "1px solid #01008B",
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #01008B",
                        },
                        cursor: "pointer",
                      },
                    }}
                    error={errors.percentage && formSubmitted}
                    helperText={formSubmitted ? errorMessages.percentage : ""}
                    type="number"
                    InputLabelProps={{ className: "mulish" }}
                    InputProps={{
                      classes: { input: "mulish" },
                      inputProps: { max: 100, min: 0 },
                    }}
                  />
                </FormControl>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "120px",
                  height: "30px",
                  marginRight: "10px",
                 fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={resetFormFields}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: "120px",
                  height: "30px",
                 fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={handleAddComponent}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <PoprchModal
        cardValue={cardValue}
        setCardValue={(data) => {
          setSearchvalue(data?.name);
          setCardValue(data);
          setFormda({
            ...formda,
            empId: data.id,
            employeeName: data.name,
          });
          setErrors({ ...errors, empId: false });
          setErrorMessages({ ...errorMessages, empId: "" });
        }}
        callback={() => {}}
        searchModal={searchModal}
        setSearchModal={setSearchModal}
        config={{ salary: true }}
      />
    </Box>
  );
}
